var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import cls from 'classnames';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { useLocationContext } from '../hooks/useLocationContext';
import { DEFAULT_LOCALE, localeMap } from '../config';
dayjs.extend(advancedFormat);
export function Date(_a) {
    var { datetime, className } = _a, props = __rest(_a, ["datetime", "className"]);
    const { locale } = useLocationContext();
    if (!datetime) {
        return null;
    }
    const theDatetime = typeof datetime === 'string' ? datetime : datetime.toISOString();
    const finalClassName = cls('WhSearch-Date', className);
    const formattedDateTime = useMemo(() => dayjs(datetime)
        .locale(localeMap[locale || DEFAULT_LOCALE])
        .format('ddd Do MMM'), [datetime, locale]);
    return (React.createElement("time", Object.assign({}, props, { className: finalClassName, dateTime: theDatetime }), formattedDateTime));
}
//# sourceMappingURL=Date.js.map